var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-title" },
                      [
                        _c("b-row", [_c("h1", [_vm._v("Transaction Ledger")])]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("span", [
                            _vm._v(
                              "Comprehensive view of all VIBANs, transactions, and financial reconciliation"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "stats" },
                      _vm._l(_vm.stats, function (stat, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            style: {
                              "border-left": "4px solid " + stat.border,
                            },
                            on: {
                              click: function ($event) {
                                stat.status != null
                                  ? _vm.selectStatus(stat.status)
                                  : stat.type != null
                                  ? _vm.selectType(stat.type)
                                  : ""
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", [_vm._v(_vm._s(stat.title))]),
                              _vm._v(" "),
                              _c("span", { style: { color: stat.color } }, [
                                _vm._v(
                                  _vm._s(
                                    index == 0 || index == 1
                                      ? "€" + Number(stat.number).toFixed(2)
                                      : stat.number
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isAlertOpen
                  ? _c("alert-modal", [
                      _c("span", [
                        _c("i", { staticClass: "fa-solid fa-circle-check" }),
                        _vm._v("Transaction sucessfully unreconciled"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filters" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "filters-items" },
                      [
                        _c("div", { staticClass: "filter-item" }, [
                          _c("span", { staticClass: "filter-item-title" }, [
                            _vm._v("Search"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.paginationObj.Search,
                                expression: "paginationObj.Search",
                              },
                            ],
                            staticClass: "filter-item-content",
                            attrs: {
                              type: "text",
                              placeholder:
                                "Search by VIBAN, client number, reference, amount or recon ref...",
                            },
                            domProps: { value: _vm.paginationObj.Search },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.paginationObj,
                                    "Search",
                                    $event.target.value
                                  )
                                },
                                function (event) {
                                  return (
                                    (_vm.paginationObj.Search =
                                      event.target.value),
                                    _vm.submit()
                                  )
                                },
                              ],
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.submit()
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "filter-item-title text-ellipsis",
                              },
                              [_vm._v("Type")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "filter-item-content d-flex justify-content-between py-2 px-3",
                                attrs: { id: "type-picker-link", href: "#" },
                              },
                              [
                                _c("span", { staticClass: "fixed-span-size" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        this.paginationObj.Types == null
                                          ? "All Types"
                                          : _vm.types.filter(function (item) {
                                              if (
                                                item.code ==
                                                this$1.paginationObj.Types
                                              ) {
                                                return item
                                              }
                                            })[0].label
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-light fa-chevron-down",
                                  attrs: {
                                    size: "17px",
                                    id: "action-type-chevron",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "type-picker-link",
                                  triggers: "focus",
                                  placement: "bottom",
                                  "custom-class": "popover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(_vm.types, function (type, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        class: [
                                          "popover-option",
                                          {
                                            "popover-option-selected":
                                              type.code ==
                                              _vm.paginationObj.Types,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(type.code)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(type.label) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "filter-item-title text-ellipsis",
                              },
                              [_vm._v("Status")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "filter-item-content d-flex justify-content-between py-2 px-3",
                                attrs: { id: "status-picker-link", href: "#" },
                              },
                              [
                                _c("span", { staticClass: "fixed-span-size" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        this.paginationObj.Status == null ||
                                          this.paginationObj.Status == "all"
                                          ? "All Statuses"
                                          : _vm.statusList.filter(function (
                                              item
                                            ) {
                                              if (
                                                item.code ==
                                                this$1.paginationObj.Status
                                              ) {
                                                return item
                                              }
                                            })[0].label
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-light fa-chevron-down",
                                  attrs: {
                                    size: "17px",
                                    id: "action-type-chevron",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "status-picker-link",
                                  triggers: "focus",
                                  placement: "bottom",
                                  "custom-class": "popover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.statusList,
                                    function (status, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: [
                                            "popover-option",
                                            {
                                              "popover-option-selected":
                                                status.code == "all"
                                                  ? _vm.paginationObj.Status ==
                                                    null
                                                  : status.code ==
                                                    _vm.paginationObj.Status,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectStatus(
                                                status.code
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(status.label) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-col", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.date_start_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("common.date_start_label")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("datetime-picker", {
                                staticClass: "z-1",
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.dateBegin,
                                  "error-datepicker": _vm.dateBeginError,
                                },
                                attrs: {
                                  format: "DD/MM/YYYY",
                                  customInputParentClass: "filter-item-content",
                                  maxLength: 19,
                                  placeholderValue: _vm.$t(
                                    "common.datetime_picker_empty_date"
                                  ),
                                  inputIcon: "fa-solid fa-calendar",
                                },
                                on: { input: _vm.selectBeginDate },
                                model: {
                                  value: _vm.dateBegin,
                                  callback: function ($$v) {
                                    _vm.dateBegin = $$v
                                  },
                                  expression: "dateBegin",
                                },
                              }),
                              _vm._v(" "),
                              _vm.dateBeginError
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("errors.Data_format_invalid")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.date_end_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.date_end_label")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("datetime-picker", {
                                staticClass: "z-1",
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.dateEnd,
                                  "error-datepicker": _vm.dateEndError,
                                },
                                attrs: {
                                  format: "DD/MM/YYYY",
                                  customInputParentClass: "filter-item-content",
                                  customInputClass: "w-100",
                                  maxLength: 19,
                                  placeholderValue: _vm.$t(
                                    "common.datetime_picker_empty_date"
                                  ),
                                  inputIcon: "fa-solid fa-calendar",
                                },
                                on: { input: _vm.selectEndDate },
                                model: {
                                  value: _vm.dateEnd,
                                  callback: function ($$v) {
                                    _vm.dateEnd = $$v
                                  },
                                  expression: "dateEnd",
                                },
                              }),
                              _vm._v(" "),
                              _vm.dateEndError
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("errors.Data_format_invalid")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "filter-item-title text-ellipsis",
                              },
                              [_vm._v("Per Page")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "filter-item-content d-flex justify-content-between py-2 px-3",
                                attrs: {
                                  id: "pagination-picker-link",
                                  href: "#",
                                },
                              },
                              [
                                _c("span", { staticClass: "fixed-span-size" }, [
                                  _vm._v(_vm._s(this.paginationObj.maxResults)),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa-light fa-chevron-down",
                                  attrs: { size: "17px", id: "page-chevron" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "pagination-picker-link",
                                  triggers: "focus",
                                  placement: "bottom",
                                  "custom-class": "popover",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(
                                    [10, 20, 30, 40, 50],
                                    function (resultsPerPage, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: [
                                            "popover-option",
                                            {
                                              "popover-option-selected":
                                                resultsPerPage ==
                                                _vm.paginationObj.maxResults,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectPagination(
                                                resultsPerPage
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(resultsPerPage) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between",
                          "padding-right": "1rem",
                        },
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "1rem",
                            },
                          },
                          [
                            _vm.totalResults > 0
                              ? _c("span", [
                                  _vm._v(
                                    "Showing " +
                                      _vm._s(_vm.paginationObj.firstIndex) +
                                      " - " +
                                      _vm._s(
                                        _vm.paginationObj.Status != null ||
                                          _vm.paginationObj.Search != null ||
                                          _vm.paginationObj.country != null
                                          ? _vm.totalResults <
                                            _vm.paginationObj.maxResults
                                            ? _vm.totalResults
                                            : _vm.currentPage ==
                                              Math.ceil(
                                                _vm.totalResults /
                                                  _vm.paginationObj.maxResults
                                              )
                                            ? _vm.totalResults
                                            : _vm.currentPage *
                                              _vm.paginationObj.maxResults
                                          : _vm.totalResults <
                                            _vm.paginationObj.maxResults
                                          ? _vm.totalResults
                                          : _vm.currentPage ==
                                            Math.ceil(
                                              _vm.totalResults /
                                                _vm.paginationObj.maxResults
                                            )
                                          ? _vm.totalResults
                                          : _vm.currentPage *
                                            _vm.paginationObj.maxResults
                                      ) +
                                      " of " +
                                      _vm._s(_vm.totalResults) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c("span", { staticClass: "selected" }, [
                                  _vm._v(
                                    _vm._s(_vm.selectedItems.length) +
                                      " selected"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "clear",
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearSelection()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-classic fa-xmark",
                                    }),
                                    _vm._v("Clear"),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "1rem",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                class: [
                                  "btn btn-outline-light",
                                  {
                                    disabled:
                                      _vm.paginationObj.sortOrder == null &&
                                      _vm.paginationObj.Search == null &&
                                      _vm.paginationObj.Status == null &&
                                      _vm.paginationObj.Types == null &&
                                      _vm.paginationObj.VIBAN == null &&
                                      _vm.paginationObj.DateBegin == null &&
                                      _vm.paginationObj.DateEnd == null,
                                  },
                                ],
                                staticStyle: { color: "#000" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clearFilters()
                                  },
                                },
                              },
                              [_vm._v("Clear Filters")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline btn-tertiary",
                                on: {
                                  click: function ($event) {
                                    return _vm.refresh()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class: [
                                    "fa-classic",
                                    "fa-arrows-rotate",
                                    { rotate: _vm.isLoading },
                                  ],
                                }),
                                _vm._v(
                                  "\n                Sync Ledger\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-tertiary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportSelected()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v(
                                      "Export Selected (" +
                                        _vm._s(_vm.selectedItems.length) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportFiltered()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export Filtered"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportAll()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export All"),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.items != null
                  ? _c(
                      "div",
                      { staticClass: "card" },
                      [
                        _c("div", { staticClass: "p-6" }, [
                          _c("h2", [_vm._v("Transaction Ledger")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.totalResults) +
                                " transaction" +
                                _vm._s(_vm.totalResults > 1 ? "s" : "")
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.items.length > 0
                          ? _c(
                              "div",
                              { staticStyle: { "overflow-x": "auto" } },
                              [
                                _c("b-table", {
                                  staticClass: "table-header-border",
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "primary-key": "id",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "head(checkbox)",
                                        fn: function () {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: "all",
                                                    name: "checkAll",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.selectAll(
                                                        $event
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "cell(checkbox)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: data.item,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.toggleSelection(
                                                        $event,
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(type)",
                                        fn: function (data) {
                                          return [
                                            data.item.Type == 1 &&
                                            data.item.Direction == 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "btn btn-empty",
                                                    staticStyle: {
                                                      display: "flex",
                                                      gap: "0.5rem",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      cursor: "default",
                                                      color: "#008236",
                                                      "background-color":
                                                        "#f0fdf4",
                                                      "border-color": "#b9f8cf",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-credit-card",
                                                    }),
                                                    _vm._v(
                                                      "\n                  Payment\n                "
                                                    ),
                                                  ]
                                                )
                                              : data.item.Type == 0 &&
                                                data.item.Direction == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "btn btn-empty",
                                                    staticStyle: {
                                                      display: "flex",
                                                      gap: "0.5rem",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      cursor: "default",
                                                      color: "#1d4ed8",
                                                      "background-color":
                                                        "#eff6ff",
                                                      "border-color": "#bfdbfe",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-money-bill",
                                                    }),
                                                    _vm._v(
                                                      "\n                  Order\n                "
                                                    ),
                                                  ]
                                                )
                                              : data.item.Type == 11 ||
                                                data.item.Type == 3
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "btn btn-empty",
                                                    staticStyle: {
                                                      display: "flex",
                                                      gap: "0.5rem",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "center",
                                                      cursor: "default",
                                                      color: "#a16207",
                                                      "background-color":
                                                        "#fefce8",
                                                      "border-color": "#fef08a",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-money-bill-transfer",
                                                    }),
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          data.item.Type == 11
                                                            ? "Refund"
                                                            : data.item.Type ==
                                                              3
                                                            ? "Credit Note"
                                                            : ""
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(VIBAN)",
                                        fn: function (data) {
                                          return [
                                            data.item.VIBAN !== ""
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(data.item.VIBAN)
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(clientnumber)",
                                        fn: function (data) {
                                          return [
                                            data.item
                                              .PaymentGroupIdentifier2 !== ""
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.item
                                                        .PaymentGroupIdentifier2
                                                    )
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(reference)",
                                        fn: function (data) {
                                          return [
                                            data.item.InvoiceIdentifier !== ""
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.item
                                                        .InvoiceIdentifier
                                                    )
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(date)",
                                        fn: function (data) {
                                          return [
                                            data.item.CreationDate != ""
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isoToDDMMYYYY(
                                                        data.item.CreationDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.item.CreationDate !== ""
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                      "font-size": "0.9rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        new Date(
                                                          Date.parse(
                                                            data.item
                                                              .CreationDate
                                                          )
                                                        ).toLocaleTimeString(
                                                          "it-IT"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(duedate)",
                                        fn: function (data) {
                                          return [
                                            data.item.ExecutionDate != ""
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isoToDDMMYYYY(
                                                        data.item.ExecutionDate
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.item.CreationDate !== ""
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6a7282",
                                                      "font-size": "0.9rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.diffInDays(
                                                          data.item
                                                            .ExecutionDate,
                                                          data.item.CreationDate
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(amount)",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                style: {
                                                  color:
                                                    data.item.InvoiceType ==
                                                      "Standard" &&
                                                    data.item.Direction == 0
                                                      ? "#00a63e"
                                                      : data.item.InvoiceType ==
                                                          "Standard" &&
                                                        data.item.Direction == 1
                                                      ? "red"
                                                      : data.item.Amount >= 0
                                                      ? "#00a63e"
                                                      : "red",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      data.item.InvoiceType ==
                                                        "Standard" &&
                                                        data.item.Direction == 0
                                                        ? "+"
                                                        : data.item
                                                            .InvoiceType ===
                                                            "Standard" &&
                                                          data.item.Direction ==
                                                            1
                                                        ? "-"
                                                        : "+"
                                                    ) +
                                                    "€" +
                                                    _vm._s(
                                                      Number(
                                                        data.item.Amount
                                                      ).toFixed(2)
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(status)",
                                        fn: function (data) {
                                          return [
                                            Number(data.item.Status) == 2
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                      gap: "0.5rem",
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                    style: {
                                                      color: "#a16207",
                                                      "background-color":
                                                        "#fefce8",
                                                      "border-color": "#fef08a",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-clock",
                                                    }),
                                                    _vm._v("Pending"),
                                                  ]
                                                )
                                              : Number(data.item.Status) == 3
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                      gap: "0.5rem",
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                    style: {
                                                      color: "#008236",
                                                      "background-color":
                                                        "#f0fdf4",
                                                      "border-color": "#b9f8cf",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-circle-check",
                                                    }),
                                                    _vm._v("Clean"),
                                                  ]
                                                )
                                              : Number(data.item.Status) == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-tertiary-full",
                                                    staticStyle: {
                                                      cursor: "default",
                                                      gap: "0.5rem",
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                    style: {
                                                      color: "#c10007",
                                                      "background-color":
                                                        "#fef2f2",
                                                      "border-color":
                                                        "#c1000773",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-triangle-exclamation",
                                                    }),
                                                    _vm._v("Needs Action"),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      cursor: "default",
                                                      gap: "0.5rem",
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                  },
                                                  [_vm._v("—")]
                                                ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(reconRef)",
                                        fn: function (data) {
                                          return [
                                            data.item.Lettrage
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#155dfc",
                                                      "font-size": ".75rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "REC-" +
                                                        _vm._s(
                                                          data.item.Lettrage.padStart(
                                                            6,
                                                            "0"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(description)",
                                        fn: function (data) {
                                          return [
                                            data.item.InvoiceType ===
                                              "Standard" &&
                                            data.item.Direction == 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#4a5565",
                                                      "font-size": ".875rem",
                                                    },
                                                  },
                                                  [_vm._v("Payment received")]
                                                )
                                              : data.item.InvoiceType ===
                                                  "Standard" &&
                                                data.item.Direction == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#4a5565",
                                                      "font-size": ".875rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Order created - " +
                                                        _vm._s(
                                                          data.item.email
                                                            ? data.item.email
                                                            : "No Email"
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [_vm._v("—")]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(actions)",
                                        fn: function (data) {
                                          return [
                                            Number(data.item.Status) == 2 ||
                                            !data.item.Lettrage
                                              ? _c("span", [_vm._v("—")])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "detail-transaction-modal",
                                                      {
                                                        attrs: {
                                                          transaction:
                                                            data.item,
                                                        },
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-open",
                                                        attrs: {
                                                          id:
                                                            "unreconcile-btn-" +
                                                            data.index,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.unreconcile(
                                                              data.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-regular fa-file-xmark",
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          target:
                                                            "unreconcile-btn-" +
                                                            data.index,
                                                          triggers: "hover",
                                                          placement: "top",
                                                          "custom-class":
                                                            "popover-btn",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Unreconcile\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3503061034
                                  ),
                                }),
                                _vm._v(" "),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.items.length > 0
                          ? _c("b-row", { staticClass: "pagination" }, [
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    { inactive: _vm.currentPage === 1 },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage > 1 && _vm.previous()
                                    },
                                  },
                                },
                                [_vm._v("Previous")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Page " +
                                    _vm._s(_vm.currentPage) +
                                    " of " +
                                    _vm._s(_vm.totalPages)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: [
                                    "btn-outline-light btn",
                                    {
                                      inactive:
                                        _vm.currentPage === _vm.totalPages,
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.currentPage < _vm.totalPages &&
                                        _vm.next()
                                    },
                                  },
                                },
                                [_vm._v("Next")]
                              ),
                            ])
                          : _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    margin: "1rem 0rem",
                                    color: "#6a7282",
                                  },
                                },
                                [_vm._v("No transactions found")]
                              ),
                            ]),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "card empty" },
                      [_c("b-spinner", { attrs: { label: "Loading..." } })],
                      1
                    ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }